<template>
  <div class="divPageParent">
    <!--导航 -->
    <!-- <nav-bar></nav-bar> -->
    <DetailsNav></DetailsNav>
    <!--背景图及视频展示 -->
    <head-first-widget
      :logoImg="baseData.detailLogoImage.url"
      :name="baseData.name"
      :description="baseData.description"
      :lastUpdate="baseData.lastUpdate"
      :type="baseData.trade.name"
      :numItems="numItems"
      :pVideoUrl="baseData.pVideoUrl"
      :industryLogoUrl="industryLogoUrl"
      :linkData="linkData"
    ></head-first-widget>
    <!--用户前后台演示 -->
    <user-display-widge
      :displayData="displayData"
      :linkData="linkData"
      type="web"
      hoverColor="web"
      btnInitColor="#394ee9"
      btnHoverColor="#1326b2"
      :lastUpdate="baseData.lastUpdate"
    ></user-display-widge>
    <flow-widget
      :flowData="flowData"
      :baseHeight="baseHeight"
      :localItemIndex="localItemIndex"
      class="web_scroll"
    ></flow-widget>
    <div class="divOffsetParent">
      <base-course-widget
        :baseTitle="baseTitle"
        :baseDescrible="baseDescrible"
        :baseBg="baseBg"
        :baseDetails="baseDetails"
        :baseBgUrl="baseBgUrl"
      ></base-course-widget>
      <work-advice-widge
        :title="adviceTitle"
        :desc="adviceDesc"
        :bgFont="adviceBgFont"
        :peopleUrl="advicePeopleUrl"
        :explain="adviceExplain"
        :details="adviceDetails"
        :bgDetailsUrl="adviceBgDetailsUrl"
        :bgUrl="adviceBgUrl"
        :bgCrapezoidal="adviceBgCrapezoidal"
      ></work-advice-widge>
      <frame-work-widge
        :data="functionFrameWorkWidgeData"
        style="padding-bottom:0"
      >
        <title-widge
          :title="functionTitle"
          :desc="functionSubTitle"
        ></title-widge>
      </frame-work-widge>
      <frame-work-widge :data="technologyFrameWorkWidgeData">
        <title-widge
          :title="technologyTitle"
          :desc="technologySubTitle"
        ></title-widge>
      </frame-work-widge>
      <study-path-widge
        :title="studyTitle"
        :desc="studyDesc"
        :bgFont="studyBgFont"
        :bgUrl="studyBgUrl"
        :courseData="courseOutData"
      ></study-path-widge>
      <techer-display-widge
        :title="teacherTitle"
        :desc="teacherDesc"
        :bgFont="teacherBgFont"
        :imgUrls="teacherUrls"
      ></techer-display-widge>
    </div>
    <bottom-widge></bottom-widge>
  </div>
</template>
<script>
// import navBar from "./../../../components/navBar";
import DetailsNav from "./../../../components/detailsNav.vue";
import bottomWidge from "./../../../components/bottomWidge";
import { Content } from "../../../../gqlapi/ContentDetail.js";
import headFirstWidget from "./components/headFirstWidget";
import UserDisplayWidge from "./../common/components/userDisplayWidge";
import flowWidget from "./../common/components/flowWidget";
import baseCourseWidget from "./components/baseCourseWidget";
import workAdviceWidge from "./components/workAdviceWidge";
import frameWorkWidge from "./../common/components/frameWorkWidge";
import studyPathWidge from "./components/studyPathWidge";
import techerDisplayWidge from "./components/techerDisplayWidge";
import { pushArr,elTabsAddEventListener } from "./../../../js/tools";
import titleWidge from "./asserts/common/components/commonTitleWidge"
export default {
  components: {
    // navBar,
    DetailsNav,
    headFirstWidget,
    UserDisplayWidge,
    flowWidget,
    baseCourseWidget,
    workAdviceWidge,
    frameWorkWidge,
    studyPathWidge,
    techerDisplayWidge,
    bottomWidge,
    titleWidge
  },
  data() {
    return {
      baseData: {
        detailLogoImage: {
          url: "",
        },
        trade: {},
        functionalArchitectureDiagram: {
          url: "",
        },
        technicalArchitectureDiagram: {
          url: "",
        },
      },
      numItems:[],
      industryLogoUrl: "",
      displayData: [],
      linkData: [],
      flowData: [],
      baseHeight: 0,
      localItemIndex: 0,
      baseTitle: "",
      baseDescrible: "",
      baseBg: "",
      baseDetails: [],
      baseBgUrl: "",
      adviceTitle: "",
      adviceDesc: "",
      adviceBgFont: "",
      advicePeopleUrl: "",
      adviceExplain: "",
      adviceDetails: [],
      adviceBgDetailsUrl: "",
      adviceBgUrl: "",
      adviceBgCrapezoidal: "/img/work-advice-bg-trapezoidal.png",
      functionFrameWorkWidgeData: {},
      functionTitle: "",
      functionSubTitle: "",
      technologyFrameWorkWidgeData: {},
      technologyTitle: "",
      technologySubTitle: "",
      studyTitle: "",
      studyDesc: "",
      studyBgFont: "",
      studyBgUrl: "",
      teacherTitle: "",
      teacherDesc: "",
      teacherBgFont: "",
      courseOutData: [],
      teacherUrls: [],
      oldHeight: 0,
      scrollClass: {
        pInit: "parent web_scroll",
        pChange: "parent web_scroll  p-change",
        cInit: "ul-init",
        cChange: "",
      },
      scrollFlag: {
        top: true,
        bottom: true,
      },
    };
  },
  created() {
    this.getData();
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    Object.freeze(this.scrollFlag);
    Object.freeze(this.scrollClass);
    Object.freeze(this.oldHeight);

    // 埋点
    this.$trackEvent("详情页面", "mounted", this.baseData.name);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getDisplayData() {
      let data = this.baseData;
      let arr = [];
      for (let item of data.coverImageGroupList) {
        let imgs = [];
        item.imageAndLink.forEach((v) => {
          if (v.image) {
            imgs.push(v.image.url);
          }
        });
        arr.push({
          desc: item.groupName,
          type: item.imageType,
          imgs: imgs,
        });
      }
      this.displayData = arr;
      this.linkData = data.demoTitleLinkGroup;
    },
    handleScroll() {
      let oldHeight = this.oldHeight;
      let localHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let scrollHeight = this.baseHeight;
      let eles = document.querySelector(".divOffsetParent").children;
      for (let index in eles) {
        if (localHeight > eles[index].offsetTop + scrollHeight - 10) {
          this.localItemIndex = Number(index);
        }
      }
      let scrollFlag = this.scrollFlag;
      let scrollClass = this.scrollClass;
      if (oldHeight > localHeight) {
        //向上
        if (scrollFlag.top && localHeight < scrollHeight) {
          scrollFlag.top = false;
          scrollFlag.bottom = true;
          let parent = document.querySelector(".web_scroll");
          let child = parent.children[0];
          parent.className = scrollClass.pInit;
          child.className = scrollClass.cInit;
        }
      } else {
        //向下
        if (scrollFlag.bottom && localHeight > scrollHeight) {
          scrollFlag.top = true;
          scrollFlag.bottom = false;
          let parent = document.querySelector(".web_scroll");
          let child = parent.children[0];
          parent.className = scrollClass.pChange;
          child.className = scrollClass.cChange;
        }
      }
      this.oldHeight = localHeight;
    },
    getData() {
        this.$axios.post('/api',{
            operationName: "Content",
            variables:{
              id: sessionStorage.getItem("detailsId"),
            },
            query: Content
        })
        .then((res) => {
          this.baseData = res.data.data.pContent;
         
          this.getHeadFirstWidgeData();
          this.getDisplayData();
          this.getCourseData();
          this.getFlowData();
          this.getJobAdvice();
          this.getFrameWorkWidgeData();
          this.getBaseCourseData();
          this.getTeacherData();
          // this.getBaseHeight();
        });
    },
    getHeadFirstWidgeData() {
      let baseData = this.baseData;
      this.industryLogoUrl = baseData.trade
        ? baseData.trade.iconFile
          ? baseData.trade.iconFile.url
          : ""
        : "";
      let numItems = [];
      pushArr(baseData.baseInfoTitle1, numItems);
      pushArr(baseData.baseInfoTitle2, numItems);
      pushArr(baseData.baseInfoTitle3, numItems);
      pushArr(baseData.baseInfoTitle4, numItems);
      pushArr(baseData.baseInfoTitle5, numItems);
      pushArr(baseData.baseInfoTitle6, numItems);
      this.numItems = numItems;
    },
    getTeacherData() {
      let data = this.baseData;
      let teacherData = data.detailsList[5] ? data.detailsList[5] : {};
      this.teacherTitle = teacherData.title;
      this.teacherDesc = teacherData.subTitle;
      let teacherUrls = [];
      let lieBiao = teacherData.lieBiao ? teacherData.lieBiao : [];
      for (let item of lieBiao) {
        teacherUrls.push({
          name: item.title,
          quarters: item.subTitle,
          headerImage: item.image,
          details: item.description,
        });
      }
      this.teacherUrls = teacherUrls;
    },
    getFrameWorkWidgeData() {
      let baseData = this.baseData;
      let functionFrameWorkWidgeData = baseData.detailsList[2];
      this.functionFrameWorkWidgeData = functionFrameWorkWidgeData;
      this.functionTitle = functionFrameWorkWidgeData.title;
      this.functionSubTitle = functionFrameWorkWidgeData.subTitle;
      let technologyFrameWorkWidgeData = baseData.detailsList[3];
      this.technologyFrameWorkWidgeData = technologyFrameWorkWidgeData;
      this.technologyTitle = technologyFrameWorkWidgeData.title;
      this.technologySubTitle = technologyFrameWorkWidgeData.subTitle;
    },
    getJobAdvice() {
      let data = this.baseData;
      let jobAdviceData = data.detailsList[1] ? data.detailsList[1] : {};
      this.adviceTitle = jobAdviceData.title;
      this.adviceDesc = jobAdviceData.subTitle;
      let tuwen = jobAdviceData.tuWen;
      this.advicePeopleUrl = tuwen.image.url;
      this.adviceExplain = jobAdviceData.navTitle;
      this.adviceDetails = tuwen.description.split("\n");
      this.adviceBgDetailsUrl = tuwen.bgImage.url;
      this.adviceBgUrl = tuwen.textBgImage.url;
      // this.adviceBgFont = jobAdviceData.topBackgroundTitle;
      // this.adviceBgCrapezoidal = 发展建议的梯形图标
    },
    getBaseCourseData() {
      let data = this.baseData;
      let baseCourseData = data.detailsList[0] ? data.detailsList[0] : {};
      this.baseTitle = baseCourseData.title;
      this.baseDescrible = baseCourseData.subTitle;
      let baseDetails = [];
      let tuWen = baseCourseData.tuWen ? baseCourseData.tuWen : {};
      this.baseBgUrl = tuWen.textBgImage ? tuWen.textBgImage.url : "";
      for (let item of baseCourseData.lieBiao) {
        baseDetails.push({
          url: item.image.url,
          desc: item.title,
        });
      }
      this.baseDetails = baseDetails;
      // this.baseBg = baseCourseData.topBackgroundTitle;
    },
    //获取流程管理的数据
    getFlowData() {
      let detailsList = this.baseData.detailsList;
      let arr = [];
      detailsList.forEach((item, index) => {
        arr.push({
          index: index,
          desc: item.navTitle,
        });
      });
      this.flowData = arr;
    },
    infoData(title, desc, name) {
      let items = [];
      let obj = {};
      for (let f = 0; f < title.length; f++) {
        for (let d = 0; d < desc.length; d++) {
          if (f === d) {
            if (title[f] !== null && title[f] !== "") {
              if (name === "base") {
                let baseInfo = desc[d];
                if (desc[d] !== null && desc[d] !== "") {
                  baseInfo = desc[d].split("\n");
                } else {
                  baseInfo = desc[d];
                }
                obj = {
                  title: title[f],
                  desc: baseInfo,
                };
              } else {
                let videoName = title[f].lastIndexOf("[");
                let videoUrl = title[f].lastIndexOf("(");

                let names = "";
                let urls = "";
                if (videoName > 0) {
                  names = title[f].substring(
                    title[f].indexOf("[") + 1,
                    title[f].indexOf("]")
                  );
                }
                if (videoUrl > 0) {
                  urls = title[f].substring(
                    title[f].indexOf("(") + 1,
                    title[f].indexOf(")")
                  );
                }
                let videoObj = {};
                videoObj = {
                  name: names,
                  url: urls,
                };
                obj = {
                  title: title[f],
                  desc: desc[d],
                  video: videoObj,
                };
              }
              items.push(obj);
            }
          }
        }
      }
      let arr = [];
      items.forEach(function(item) {
        if (item.desc !== null && item.desc !== "") {
          var items = item.desc.split(/;|；/);
          var descData = items.map((val) => {
            var arr = val.split("：");
            return { title: arr[0], content: arr[1] };
          });
          let couseOutBase = {
            titles: item.title.replace(/\[.*?\]/g, "").replace(/\(.*?\)/g, ""),
            desc: descData,
            video: item.video,
          };
          arr.push(couseOutBase);
        }
      });
      this.courseOutData = arr;
      setTimeout(function() {
        elTabsAddEventListener(document, arr.length);
      }, 1000);
    },
    getCourseData() {
      let pContent = this.baseData;
      let courseOutlineTitle = [
        pContent.courseOutlineTitle1,
        pContent.courseOutlineTitle2,
        pContent.courseOutlineTitle3,
        pContent.courseOutlineTitle4,
        pContent.courseOutlineTitle5,
        pContent.courseOutlineTitle6,
        pContent.courseOutlineTitle7,
        pContent.courseOutlineTitle8,
        pContent.courseOutlineTitle9,
        pContent.courseOutlineTitle10,
        pContent.courseOutlineTitle11,
        pContent.courseOutlineTitle12,
        pContent.courseOutlineTitle13,
        pContent.courseOutlineTitle14,
        pContent.courseOutlineTitle15,
        pContent.courseOutlineTitle16,
        pContent.courseOutlineTitle17,
        pContent.courseOutlineTitle18,
        pContent.courseOutlineTitle19,
        pContent.courseOutlineTitle20,
      ];
      let courseOutlineDesc = [
        pContent.courseOutlineDesc1,
        pContent.courseOutlineDesc2,
        pContent.courseOutlineDesc3,
        pContent.courseOutlineDesc4,
        pContent.courseOutlineDesc5,
        pContent.courseOutlineDesc6,
        pContent.courseOutlineDesc7,
        pContent.courseOutlineDesc8,
        pContent.courseOutlineDesc9,
        pContent.courseOutlineDesc10,
        pContent.courseOutlineDesc11,
        pContent.courseOutlineDesc12,
        pContent.courseOutlineDesc13,
        pContent.courseOutlineDesc14,
        pContent.courseOutlineDesc15,
        pContent.courseOutlineDesc16,
        pContent.courseOutlineDesc17,
        pContent.courseOutlineDesc18,
        pContent.courseOutlineDesc19,
        pContent.courseOutlineDesc20,
      ];
      this.infoData(courseOutlineTitle, courseOutlineDesc, "out");
      let studyPathData = pContent.detailsList[4]
        ? pContent.detailsList[4]
        : {};
      this.studyTitle = studyPathData.title;
      this.studyDesc = studyPathData.subTitle;
      this.studyBgUrl = studyPathData.tuWen
        ? studyPathData.tuWen.image
          ? studyPathData.tuWen.image.url
          : ""
        : "";
      // this.studyBgFont = studyPathData.topBackgroundTitle;
    },
  },
};
</script>
<style>
.div-swiper-teacher .swiper-container .swiper-wrapper .swiper-slide .divImg img{
  width: auto;
  height: 220px;
}
.div-swiper-teacher .swiper-container .swiper-wrapper .swiper-slide .divImg .divDesc{
  height: 240px;
  overflow: hidden;
}
</style>
<style lang="scss" scoped>
@import "./asserts/scss/index.scss";
.divOffsetParent {
  position: relative;
  overflow: hidden;
  top: -38px;
}
</style>
<style lang="scss">
.divPageParent {
  .divUserDisplay {
    .el-tabs__item.is-active {
      color: rgba(57,78,233,1) !important;
      border-bottom: 5px solid rgba(57,78,233,1);
    }
  }
}
</style>
